module.exports = __webpack_public_path__ + "img/ico_fcu_2.95eed13e.png";